import { render, staticRenderFns } from "./SafetyMeasuresDeviceVerificationAndRequirements.vue?vue&type=template&id=7b1d071e&scoped=true&"
import script from "./SafetyMeasuresDeviceVerificationAndRequirements.vue?vue&type=script&lang=js&"
export * from "./SafetyMeasuresDeviceVerificationAndRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d071e",
  null
  
)

export default component.exports